import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QuestionBase } from 'core/components/forms';
import { Client } from 'core/models/client';
import { ClientsService } from 'core/services/clients.service';
import { SftpConfigurationsService } from '../../services/sftp-configurations.service';
import { ClientSftpQuestionsService } from '../../questions-services/client-sftp-questions.service';

@Component({
  selector: 'lms-client-sftp-editor',
  templateUrl: './client-sftp-editor.component.html',
  styleUrls: ['./client-sftp-editor.component.scss'],
  providers: [ClientSftpQuestionsService, SftpConfigurationsService]
})
export class ClientSftpEditorComponent implements OnInit, OnChanges {
  @Input() client: Client;
  @Output() saved = new EventEmitter<Client>();
  public questions: QuestionBase<any>[];
  public sftpConfig: any = null;
  defaultSftpConfig: any = {
    enabled: false,
    reports: {
      interval: '',
      licenses: {
        columns: [
          'user_email',
          'pid',
          'group_name',
          'points',
          'start_date',
          'end_date',
          'status',
          'last_connection',
          'gameProgress',
          'playTime'
        ]
      },
      clientId: ''
    }
  };

  constructor(
    public sftpQuestionsService: ClientSftpQuestionsService,
    public sftpConfigurationsService: SftpConfigurationsService,
    public clientsService: ClientsService,
    public route: ActivatedRoute
  ) {}

  ngOnInit() {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.client) {
      this.sftpConfig = null;
      if (this.client) {
        this.sftpConfigurationsService
          .getSftpConfig(this.client.id)
          .then((sftpConfig) => {
            this.sftpConfig = sftpConfig;
            this.setQuestions();
          })
          .catch((error) => {
            if (error.errorCode == 'NOT_FOUND_SFTP_CONFIG') {
              this.defaultSftpConfig.clientId = this.client.id;
              this.sftpConfig = this.defaultSftpConfig;
              this.setQuestions();
            }
          });
      } else {
        this.setQuestions();
      }
    }
  }

  async setQuestions() {
    this.questions = await this.sftpQuestionsService.getQuestions(this.sftpConfig);
  }

  submit(sftpConfig: any) {
    const sftpConfigFormData = {
      enabled: sftpConfig.enabled,
      reports: { interval: +sftpConfig.interval, licenses: { columns: [...sftpConfig.columns] } }
    };
    this.sftpConfigurationsService
      .updateSftpConfig(this.client.id, sftpConfigFormData)
      .then((updatedSftpConfig) => {
        this.sftpConfig = updatedSftpConfig;
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
